/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerGetHistoryQueryResponse, ChatControllerGetHistoryPathParams, ChatControllerGetHistoryQueryParams, ChatControllerGetHistory401, ChatControllerGetHistory403 } from "../../models/chatController/ChatControllerGetHistory";

function getChatControllerGetHistoryUrl(scopeId: ChatControllerGetHistoryPathParams["scopeId"]) {
  const res = { method: 'GET', url: `/api/v1/chat/history/${scopeId}` as const }  
  return res
}

/**
 * @summary Get chat history for a scope
 * {@link /api/v1/chat/history/:scopeId}
 */
export async function chatControllerGetHistory(scopeId: ChatControllerGetHistoryPathParams["scopeId"], params?: ChatControllerGetHistoryQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ChatControllerGetHistoryQueryResponse, ResponseErrorConfig<ChatControllerGetHistory401 | ChatControllerGetHistory403>, unknown>({ method : "GET", url : getChatControllerGetHistoryUrl(scopeId).url.toString(), params, ... requestConfig })  
  return res.data
}